module.exports = class NurseMetaData {
	constructor (object) {
		this.hospitalId = object.hospitalId;
		this.id = object.id;
		this.licenceId = object.licenceId;
		this.metadataInfo = object.metadataInfo;
		this.userId = object.userId;
	}
};
